import AppBar from "@material-ui/core/AppBar"
import ListIcon from "@material-ui/icons/List"
import MoreVertIcon from "@material-ui/icons/MoreVert"
import IconButton from "@material-ui/core/IconButton"
import Fab from "@material-ui/core/Fab"
import Toolbar from "@material-ui/core/Toolbar"
import Tooltip from "@material-ui/core/Tooltip"
import Typography from "@material-ui/core/Typography"
import ExitToAppIcon from "@material-ui/icons/ExitToApp"
import PersonIcon from "@material-ui/icons/Person"
import SettingsIcon from "@material-ui/icons/Settings"
import cal from "clsx"
import React, { useContext } from "react"
import { AppContext } from "Views/Home/context"
import { useTopBarStyles } from "./style"
import { redirectProfile, redirectLogin } from "Methods/user"

export default () => {
    const classes = useTopBarStyles()
    const { drawerOpen, toggleDrawer, user, activeMenu } = useContext(AppContext)
    const { uid = "" } = user || {}
    return (
        <AppBar
            position="absolute"
            className={cal(
                classes.appBar,
                drawerOpen && classes.appBarShift,
            )}
        >
            <Toolbar className={classes.toolbar}>
                <Fab onClick={() => toggleDrawer()} size="small" className={classes.FabIcon}>
                    {drawerOpen ?  <MoreVertIcon /> : <ListIcon />}
                </Fab>
                <Typography component="h1" variant="h6" color="inherit" noWrap className={classes.title}>
                    {activeMenu ? activeMenu.name : ""}
                </Typography>
                <Tooltip title="设置">
                    <IconButton onClick={redirectProfile}>
                        <SettingsIcon />
                    </IconButton>
                </Tooltip>
                <Tooltip title={uid ? "退出登录" : "登录"}>
                    <IconButton onClick={redirectLogin}>
                        { uid ? <ExitToAppIcon /> : <PersonIcon /> }
                    </IconButton>
                </Tooltip>
            </Toolbar>
        </AppBar>
    )
}
